import React from "react";

import BetSlipStore from "@state/bet-slip/BetSlipStore";
import { useBetSlipCurrentShareUrl } from "@state/hooks/offer/useBetSlipCurrentShareUrl";
import { copyTextToClipboard } from "@utils/common/clipboard";
import { observer } from "mobx-react";

export default observer(function BetSlipCurrentShareButton(props: {
	store: BetSlipStore;
}) {
	const buildShareUrl = useBetSlipCurrentShareUrl(props.store);

	if (
		props.store.betSlipState.isOneClickBetActive ||
		props.store.betSlipState.clickedTips.length == 0
	) {
		return null;
	}

	return (
		<button
			className="slip__head__btn btn btn--square btn--square--reset btn--ghost"
			disabled={props.store.isSubmitDisabled}
		>
			<i
				className="u-icon u-icon--xsml u-icon--share"
				onClick={() => {
					const linkUrl = buildShareUrl();

					copyTextToClipboard(linkUrl);
				}}
			></i>
		</button>
	);
});
